(function () {
    'use strict';

    var app = angular.module('app');

    app.controller('CoachCtrl', ['$scope', '$filter', 'gtm', 'Account', 'api', 'CONFIG', '$timeout', function ($scope, $filter, gtm, Account, api, CONFIG, $timeout) {

        var model = {
            me: {},
            all: [],
            chart: [],
            charts: [],
            activeChart: {},
            top: [], //top coach highlights
            sorting: '-id',
            filters: [],
            query: {}
        };

        var data = {
            sorting: [{
                    id: '-id',
                    name: CONFIG.app.locale["sortby_createdDate"]
                },
                {
                    id: '-rating',
                    name: CONFIG.app.locale["sortby_rating"]
                },
                {
                    id: 'lastName',
                    name: CONFIG.app.locale["sortby_name"]
                },
            ],
            paging: {
                all: {
                    items: 40, // x page
                    page: 1
                },
                chart: {
                    items: 10, // x page
                    page: 1
                }
            },
            coaches: [{
                id: 0,
                name: CONFIG.app.locale["coach_community"]
            }, {
                id: 1,
                name: CONFIG.app.locale["coach_arena"]
            }, {
                id: 2,
                name: CONFIG.app.locale["coach_top"]
            }],
            _searchTerm: ""
        };

        var scope = {
            model: model,
            data: data,
            all: all,
            chart: chart,
            mychart: mychart,
            onChartTypeChange: onChartTypeChange,
            setFilter: setFilter,
            removeFilter: removeFilter
        };

        angular.extend($scope, scope);

        function all() {
            api.coach.chart.all().then(function (response) {
                setCharts(response);
                model.all = model.chart.total;
            });
            api.coach.top().then(function (response) {
                model.top = response.data || [];
            });
        }

        function chart() {
            api.coach.chart.all().then(function (response) {
                setCharts(response);
            });
        }

        function mychart() {
            api.coach.chart.me().then(function (response) {
                setCharts(response);
                if (Account.user) {
                    setMe(Account.user);
                } else {
                    Account.getUser().then(function (user) {
                        setMe(user);
                    });
                }
            });
        }

        function setMe(user) {
            var data = $filter('filter')(model.chart.total, {
                id: user.id
            });
            if (data && data.length > 0) {
                model.me = data[0];
                var currentMonthChart = {
                    ranking: '-',
                    rating: 0
                };
                if (model.me.rankingByMonths && model.me.rankingByMonths.length) {
                    var current = $filter('filter')(model.me.rankingByMonths, {
                        date: getMonthKey('current')
                    });
                    if (current.length) {
                        currentMonthChart.ranking = current[0].ranking;
                        currentMonthChart.rating = current[0].rating;
                    }
                };
                model.me.currentMonthChart = currentMonthChart;
            }
        }

        function getMonthKey(range) {
            var date = new Date();
            switch (range) {
                case 'previous':
                    date.setMonth(date.getMonth() - 1);
                    break;
            }
            return date.toISOString().substring(0, 7).replace('-', '');
        }

        function setCharts(response) {
            model.chart = response.data || [];
            model.charts = [{
                type: 'total',
                list: $filter('filter')(model.chart.total, {
                    type: 0 /*community coach*/
                })
            }, {
                type: 'currentMonth',
                list: model.chart.currentMonth
            }, {
                type: 'previousMonth',
                list: model.chart.previousMonth
            }];
            onChartTypeChange('total');
        }

        function onChartTypeChange(type) {
            model.activeChart = $filter('filter')(model.charts, {
                type: type
            })[0];
            data.paging.chart.page = 1;
        }

        //#region Search Index
        function setFilter(type) {
            $timeout(function () {
                var filter = model[type];
                if (filter) {
                    filter.type = type;
                    var same = $filter('filter')(model.filters, function (item) {
                        return item.type == type;
                    });
                    if (same.length)
                        model.filters.splice(model.filters.indexOf(same[0]), 1);
                    model.filters.push(filter);
                }
            });
        }

        function removeFilter(item) {
            model[item.type] = null;
            model.filters.splice(model.filters.indexOf(item), 1);
        }

        function setQuery() {
            $timeout(function () {
                var query = {};
                angular.forEach(model.filters, function (filter) {
                    switch (filter.type) {
                        case 'type':
                            query[filter.type] = filter.id;
                            break;
                        case 'search':
                            if (filter.name != "" && filter.name != data._searchTerm) {
                                data._searchTerm = filter.name;
                                gtm.push({
                                    event: 'Search',
                                    type: 'Coach',
                                    query: filter.name
                                });
                            }
                            query["$"] = filter.name; //all
                            break;
                        default:
                            query[filter.type] = {
                                id: filter.id
                            };
                    }

                });
                model.query = query;
                data.paging.all.page = 1;
            });
        }

        $scope.$watchCollection('model.filters', function () {
            setQuery();
        })
        $scope.$watch('model.search.name', function () {
            setQuery();
        })
        //#endregion Search

    }]);

})();